import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Events, EventsParams, Preference, Summary } from '../summary.model';




export enum SummaryActionTypes {
  GetSummary = '[Summary] Get Summary',
  GetSummarys = '[Summary] Get Summarys',
  LoadSummarys = '[Summary] Load Summarys',
  AddSummary = '[Summary] Add Summary',
  UpsertSummary = '[Summary] Upsert Summary',
  AddSummarys = '[Summary] Add Summarys',
  UpsertSummarys = '[Summary] Upsert Summarys',
  UpdateSummary = '[Summary] Update Summary',
  UpdateSummarys = '[Summary] Update Summarys',
  DeleteSummary = '[Summary] Delete Summary',
  DeleteSummarys = '[Summary] Delete Summarys',
  ClearSummarys = '[Summary] Clear Summarys',
  GetSummaryFail = '[Summary] Get Summary Fail',
  NoSummaryInfo = '[Summary] No Summary Info',
  GetPreferences = '[Summary] Get Preferences',
  UpsertPreferences = '[Summary] Upsert Preferences',
  UpdatePreferences = '[Summary] Update Preferences',
  GetPreferencesFail = '[Summary] Update Preferences Fail',
  NoPreferencesInfo = '[Summary] No PreferencesInfo',
  GetSummaryDetail = '[Summary] Get Summary Detail',
  GetSummaryDetailSuccess = '[Summary] Get Summary Detail Success',
  GetSummaryDetailFail = '[Summary] Get Summary Detail Fail',
  UpdateAccountPreferenceWithAuthOTP = '[Summary] Update Account Preference With AuthOTP',
  UpdateAccountPreferenceWithAuthOTPFail = '[Summary] Update Account Preference With AuthOTP Fail',
  DeleteMobile = '[Summary] Delete Mobile',
  DeleteMobileFail = '[Summary] Delete Mobile Fail',
}

export class GetSummary {
  readonly type = SummaryActionTypes.GetSummary;

  constructor(public payload: any = null) {}
}

export class GetSummarys {
  readonly type = SummaryActionTypes.GetSummarys;

  constructor(public payload: any = null) {}
}

export class LoadSummarys implements Action {
  readonly type = SummaryActionTypes.LoadSummarys;

  constructor(public payload: { summarys: Summary[] }) {}
}

export class AddSummary implements Action {
  readonly type = SummaryActionTypes.AddSummary;

  constructor(public payload: { summary: Summary }) {}
}

export class UpsertSummary implements Action {
  readonly type = SummaryActionTypes.UpsertSummary;

  constructor(public payload: { summary: Summary }) {}
}

export class AddSummarys implements Action {
  readonly type = SummaryActionTypes.AddSummarys;

  constructor(public payload: { summarys: Summary[] }) {}
}

export class UpsertSummarys implements Action {
  readonly type = SummaryActionTypes.UpsertSummarys;

  constructor(public payload: { summarys: Summary[] }) {}
}

export class UpdateSummary implements Action {
  readonly type = SummaryActionTypes.UpdateSummary;

  constructor(public payload: { summary: Update<Summary> }) {}
}

export class UpdateSummarys implements Action {
  readonly type = SummaryActionTypes.UpdateSummarys;

  constructor(public payload: { summarys: Update<Summary>[] }) {}
}

export class DeleteSummary implements Action {
  readonly type = SummaryActionTypes.DeleteSummary;

  constructor(public payload: { id: string }) {}
}

export class DeleteSummarys implements Action {
  readonly type = SummaryActionTypes.DeleteSummarys;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearSummarys implements Action {
  readonly type = SummaryActionTypes.ClearSummarys;
}

export class GetSummaryFail implements Action {
  readonly type = SummaryActionTypes.GetSummaryFail;
}

export class NoSummaryInfo implements Action {
  readonly type = SummaryActionTypes.NoSummaryInfo;
}

export class UpdatePreferences implements Action {
  readonly type = SummaryActionTypes.UpdatePreferences;
  constructor(public payload: Preference) {}
}

export class GetPreferences implements Action {
  readonly type = SummaryActionTypes.GetPreferences;
  constructor(public payload: any = null) {}
}

export class UpsertPreferences implements Action {
  readonly type = SummaryActionTypes.UpsertPreferences;

  constructor(public payload: { preferences: Preference }) {}
}

export class GetPreferencesFail implements Action {
  readonly type = SummaryActionTypes.GetPreferencesFail;
}

export class NoPreferencesInfo implements Action {
  readonly type = SummaryActionTypes.NoPreferencesInfo;
}

export class GetSummaryDetail implements Action {
  readonly type = SummaryActionTypes.GetSummaryDetail;

  constructor(public payload: any) {}
}

export class GetSummaryDetailSuccess implements Action {
  readonly type = SummaryActionTypes.GetSummaryDetailSuccess;

  constructor(public payload: any) {
  }
}

export class GetSummaryDetailFail implements Action {
  readonly type = SummaryActionTypes.GetSummaryDetailFail;

  constructor(public payload: any = null) {
  }
}
export class UpdateAccountPreferenceWithAuthOTP implements Action {
  readonly type = SummaryActionTypes.UpdateAccountPreferenceWithAuthOTP;
  constructor(public payload: any = null) {}
}

export class UpdateAccountPreferenceWithAuthOTPFail implements Action {
  readonly type = SummaryActionTypes.UpdateAccountPreferenceWithAuthOTPFail;
  constructor(public payload: any = null) {}
}
export class DeleteMobile implements Action {
  readonly type = SummaryActionTypes.DeleteMobile;
  constructor(public payload: any = null) {}
}

export class DeleteMobileFail implements Action {
  readonly type = SummaryActionTypes.DeleteMobileFail;
  constructor(public payload: any = null) {}
}

export type SummaryActions =
GetSummarys
 | LoadSummarys
 | AddSummary
 | UpsertSummary
 | AddSummarys
 | UpsertSummarys
 | UpdateSummary
 | UpdateSummarys
 | DeleteSummary
 | DeleteSummarys
 | ClearSummarys
 | GetSummary
 | GetSummaryFail
 | NoSummaryInfo
 | GetPreferences
 | UpdatePreferences
 | UpsertPreferences
 | GetPreferencesFail
 | NoPreferencesInfo
 | GetSummaryDetail
 | GetSummaryDetailSuccess
 | GetSummaryDetailFail
 | UpdateAccountPreferenceWithAuthOTP
 | UpdateAccountPreferenceWithAuthOTPFail
 | DeleteMobile
 | DeleteMobileFail;
